/**
 * Normalize Indian mobile numbers.
 * Only strips country code 91 when the digit string is longer than 10
 * (e.g. 9198XXXXXXXX). Never strips a leading 91 from a real 10-digit
 * mobile that happens to start with 91 (e.g. 9123456789).
 */
export const INDIAN_MOBILE_RE = /^[6-9]\d{9}$/;

export function normalizeIndianPhone(raw) {
    let cleaned = String(raw || '').replace(/\D/g, '');
    if (cleaned.startsWith('91') && cleaned.length > 10) {
        cleaned = cleaned.slice(2);
    } else if (cleaned.startsWith('0') && cleaned.length === 11) {
        cleaned = cleaned.slice(1);
    }
    // Guard: if still >10 (e.g. 0091…), keep last 10
    return cleaned.slice(-10);
}

export function isValidIndianMobile(raw) {
    const n = normalizeIndianPhone(raw);
    return n.length === 10 && INDIAN_MOBILE_RE.test(n);
}

export function formatIndianMobileE164(raw) {
    const n = normalizeIndianPhone(raw);
    return n && isValidIndianMobile(n) ? `+91${n}` : '';
}

/** Digits-only input helper for controlled phone fields (max 10 local digits). */
export function phoneInputDigits(raw) {
    return String(raw || '').replace(/\D/g, '').slice(0, 10);
}
